export enum AppLanguages {
  En = 'en',
  Ru = 'ru',
}
